import { FC, useContext } from 'react';
import { IconButton } from '@alto-avios/alto-ui';

import { useUserDetailsError } from '../../contexts/userDetailsError';
import { AuthProps } from '../Header';
import { ManageAvios } from '../ManageAvios';
import { CMSProviderContext } from '../services/content';
import { Popover } from '../Popover';

import styles from './MyAccountDetails.module.css';

export interface MyAccountProps {
  balance: number | undefined;
  name: string;
  logoutProps: AuthProps['logoutProps'];
}

export const MyAccountDetails: FC<MyAccountProps> = ({ balance, name, logoutProps }) => {
  const { header } = useContext(CMSProviderContext);
  const { accountPopoverAriaLabel } = header.data;
  const { userDetailsError, userBalanceError } = useUserDetailsError();

  const userIcon = (
    <IconButton
      data-testid="userIcon"
      emphasis="quaternary"
      styleVariant="neutral"
      aria-label={accountPopoverAriaLabel}
      iconProps={{ iconName: 'user', iconSize: '2x', iconPrefix: 'far' }}
    />
  );

  return (
    <div className={styles.userDetailsWrapper} data-testid="my-account">
      {!userDetailsError && (
        <div className={styles.text}>
          <p className={styles.name}>{name}</p>
          {balance && !userBalanceError && <p className={styles.aviosBalance}>{`${balance.toLocaleString('en-GB')} Avios`}</p>}
        </div>
      )}
      <Popover placement="bottom right" closeDelay={600} openDelay={300} trigger={userIcon} aria-label="User Details" isNonModal>
        <ManageAvios aviosBalance={balance} firstName={name} logoutProps={logoutProps} />
      </Popover>
    </div>
  );
};
